<template>
  <div class="respondents-wizard" v-if="selectedStudy">
		<div v-if="selectedStudy.recallType && selectedStudy.recallType.toLowerCase() === this.$createStudyLists.RECALL_TYPE_SCHEDULED.value.toLowerCase()">
			<scheduled-respondent-form v-on:cancel="cancelDialog = true"></scheduled-respondent-form>
		</div>
		<div v-else-if="selectedStudy.recallType && selectedStudy.recallType.toLowerCase() === this.$createStudyLists.RECALL_TYPE_UNSCHEDULED.value.toLowerCase()">
			<unscheduled-respondent-form v-on:cancel="cancelDialog = true"></unscheduled-respondent-form>
		</div>
		<div v-else-if="selectedStudy.recordStudyType">
			<record-respondent-form v-on:cancel="cancelDialog = true"></record-respondent-form>
		</div>
		<!-- <div v-else-if="selectedStudy.recordStudyType && selectedStudy.recordStudyType.toLowerCase() === this.$createStudyLists.RECORD_TYPE_CONSECUTIVE.value.toLowerCase()">
			<h1>Consecutive-Day Record Studies Do Not Support This Feature</h1>
		</div> -->
		<!-- Cancel pop up -->
		<foe-dialog
      v-model="cancelDialog"
			:dialogW="cancelDialog"
      persistent
			max-width="600px"
			class="cancel-dialog"
    >
      <v-card class="cancel-confirm-card">
        <v-card-title>Cancel</v-card-title>
        <v-card-text>Are you sure you want to cancel?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
					<v-btn
            text
						class="btn-default"
            @click="cancelDialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
						class="btn-default"
            @click="onCancel()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </foe-dialog>
	</div>
</template>

<script>
import { utilityService } from '@/services/utilityService';
export default {
	name: 'RespondentsWizard',
	props: {
	},
	metaInfo: {
		title: 'Create New Respondents Wizard'
	},
	data: () => ({
		cancelDialog: false
	}),
	mounted () {
	},
	methods: {
		async onCancel () {
			const tabsPos = await utilityService.getTabsPositionByName('Add new Respondents', this.$studyTabConfig);
			const tabs = { tabIndex: tabsPos.tabPos, subTabIndex: tabsPos.subtabPos };
			this.$store.commit('setCurrentStudyTab', tabs);
			this.$router.push('/study/home');
		}
	},
	computed: {
		selectedStudy: function () {
			return this.$store.getters.getSelectedStudy;
		}
	}
}
</script>

<style>
</style>
